import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";
import { AddAndDeleteInlineIcon } from "../../../../../components/BuilderComponents/Preview/IconPreview";
import Label from "../../../../../components/FormComponents/Label";

const EditButton = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };

  return (
    <>
      <div className="builder_form">
        <Label>{getLabelForKey("label")}</Label>
        <div className="d_flex icon-and-btn-wrap">
          <AddAndDeleteInlineIcon
            icon={editFieldData.icon}
            callbackFunction={(icon) => handleChangeInput("icon", icon)}
          />
          <Input
            value={editFieldData.label}
            name="label"
            onChange={({ target }) => handleChangeInput(target.name, target.value)}
            inputClassName="border_left_none outline_none"
          />
        </div>
      </div>
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditButton;
